import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as homeAddressActions from '../actions';
import { IHomeAddressResponse } from '../models/home-address.model';

export const archivedHomeAddressFeatureKey = 'archivedHomeAddress';

export interface ArchivedHomeAddressState {
  loadArchivedHomeAddress: string;
  loadArchivedHomeAddressSuccess: IHomeAddressResponse[];
  loadArchivedHomeAddressFailure: Error | any;
}

export const initialState: ArchivedHomeAddressState = {
  loadArchivedHomeAddress: undefined,
  loadArchivedHomeAddressSuccess: undefined,
  loadArchivedHomeAddressFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(homeAddressActions.fromHomeAddressActions.loadPreviousHomeAddress, (state, action) => ({
    ...state,
    loadArchivedHomeAddress: action.request
  })),
  on(homeAddressActions.fromHomeAddressActions.loadPreviousHomeAddressSuccess, (state, action) => ({
    ...state,
    loadArchivedHomeAddressSuccess: action.response
  })),
  on(homeAddressActions.fromHomeAddressActions.loadPreviousHomeAddressFailure, (state, action) => ({
    ...state,
    loadArchivedHomeAddressFailure: action.error
  }))
);

export const getPreviousHomeAddress = (state: ArchivedHomeAddressState) => state.loadArchivedHomeAddressSuccess;
